import axonApi from './AxonApi';

export const getChatFuelUserByPhone = async (celular) => {
  try {
    const response = await axonApi.get(
      `/internos/crm/reactivacion/dato${celular ? `?celular=${celular}` : ''}`
    );

    if (!response.data.data) {
      return {
        data: null,
        message: response.data.message,
      };
    }

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getTemplateSelect = async () => {
  try {
    const response = await axonApi.get(`internos/crm/reactivacion/template`);

    if (!response.data.data) {
      return {
        data: null,
        message: response.data.message,
      };
    }

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const sendReactivacionChatFuelUsers = async (usersIds, template, idsVenta) => {
  try {
    const response = await axonApi.post(
      `/internos/crm/reactivacion/${template}`,
      {
        ids: usersIds,
        idsVenta: idsVenta,
      }
    );

    if (response.data.status === 'Success') {
      return response.data;
    }

    return {
      data: null,
      message: response.data.message,
    };
  } catch (error) {
    console.error(error);
  }
};
